module.exports = __webpack_public_path__ + "static/media/rabbit.a2fa623b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rabbit.png
// module id = 854
// module chunks = 0